<script>
    export let row = {};
    export let checked = null;
    export let onToggleSelect = () => {};
</script>

<div class="flex flex-1 items-center justify-center">
    <input
        type="checkbox"
        checked={checked != null ? checked : row.checked}
        class="checkbox checkbox-sm"
        on:change|preventDefault={() => onToggleSelect(row)}
    />
</div>
